/**
 * A capability's native adapter is UNAVAILABLE until its own ticket lands
 * (#1691-#1695 — Auth/Device Registry, Universal/App Links, NFC, Push,
 * Location Challenge). spec.md §2.1: "כל יכולת נייטיבית חייבת לכלול fallback
 * ברור ל-Web או הודעת אי-זמינות. אין לאפשר כשל שקט." — a stub here throws
 * rather than resolving or returning something that looks like success.
 */
export function nativeAdapterUnavailable(capability) {
  throw new Error(`[platform] "${capability}" has no native adapter yet (see #1690's child tickets)`)
}
